// @ts-nocheck
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

export const productListPaginationWrapperStyles = () => {
    return css`
        justify-content: center;

        &:not(#important) /* Override breakpoint values */ {
            ${({ theme }) => css`
                margin: ${pxToRem(30) /* Store Custom Code */} 0;

                ${breakpoint("md")} {
                    margin: ${pxToRem(40) /* Store Custom Code */} 0;
                }
            `}

            &:first-child {
                margin-top: 0;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }

        @media print {
            display: none;
        }
    `;
};
